import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
  selector: "[focusInput]",
})
export class FocusDirective {
  private focus = true;
  constructor(private el: ElementRef) {}
  ngAfterViewInit() {
    if (this.el) {
      if (this.focus) this.el.nativeElement.focus();
      else this.el.nativeElement.blur();
    }
  }

  @Input() public set focusInput(val: string) {
    this.focus = val == "true" || val.length == 0;
    this.ngAfterViewInit();
  }
}
